import { render } from "./FichesTechs.vue?vue&type=template&id=4f6e45b0"
import script from "./FichesTechs.vue?vue&type=script&lang=js"
export * from "./FichesTechs.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phl/phlsupport/deploy-support-cli/front_vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__